<template>
  <div v-if="errorsItems" class="pb-2 pl-0 pr-2">
    <p class="pa-0 ma-0 red--text"
       v-for="(errorsItem, index) in errorsItems"
       :key="index">{{errorsItem}}</p>
  </div>
</template>

<script>
export default {
  name: 'server-errors',
  props: ['errorsItems'],
};
</script>
